import createReactComponent from '../createReactComponent';
export default createReactComponent('brand-bandcamp', 'IconBrandBandcamp', [
  ['path', { d: 'M8.5 6h13.5l-7 12h-13z', key: 'svg-0' }],
]);
